<ng-container *ngIf="question">
  <ng-container *ngFor="let option of question.answerOptions">
    <div class="d-flex align-items-center form-check mb-3">
      <input
        [id]="'option-' + question.id + '-' + option.id"
        [type]="question.field_type === FieldTypes.RADIO ? 'radio' : 'checkbox'"
        [checked]="answerOptionIds.includes(option.id)"
        [name]="
          question.field_type === FieldTypes.RADIO
            ? 'radio-' + question.id
            : 'checkbox-' + question.id
        "
        class="form-check-input"
        [ngStyle]="{
          pointerEvents: isInputInteractive ? 'auto' : 'none',
          opacity: 1,
          cursor: isInputInteractive ? 'pointer' : 'default'
        }"
        [attr.tabindex]="isInputInteractive ? 0 : -1"
        (change)="isInputInteractive && onOptionChange(option.id, $event)" />

      <label
        class="form-check-label ms-3 fs-14"
        [attr.for]="'option-' + question.id + '-' + option.id"
        [ngStyle]="{
          pointerEvents: isInputInteractive ? 'auto' : 'none',
          cursor: isInputInteractive ? 'pointer' : 'default'
        }">
        {{ option.answer }}
      </label>
      <ng-container
        *ngIf="
          viewState === viewStates.GRADED && hasCorrectAnswers && showAnswers
        ">
        <!-- User selected this option -->
        <ng-container *ngIf="answerOptionIds.includes(option.id)">
          <!-- Selected but incorrect -->
          <i
            *ngIf="!option.is_correct"
            class="bi bi-x color-danger fs-18 bold-icon ms-2"
            title="Your answer - Incorrect"></i>

          <!-- Selected and correct -->
          <i
            *ngIf="option.is_correct"
            class="bi bi-check color-success fs-18 bold-icon ms-2"
            title="Your answer - Correct"></i>
        </ng-container>

        <!-- User did NOT select this option, but it's correct -->
        <div
          class="form-check-label ms-2 fs-14 fw-bold"
          *ngIf="option.is_correct">
          Correct Answer
        </div>
      </ng-container>
    </div>
  </ng-container>
</ng-container>
